// extracted by mini-css-extract-plugin
export default {"searchPage":"TalentSearch_searchPage__qbl3n","pageSidebar":"TalentSearch_pageSidebar__td+RH"};